import { EquipmentService } from 'src/app/services';
import { Component, OnInit } from '@angular/core';
import { SelectItem } from 'primeng/api/selectitem';
import { EquipmentInfo, SelectedData, AccessUserInfo, UserDetail } from 'src/app/models'
import { MenuItem } from 'primeng/api/menuitem';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'bart-name-manager',
  templateUrl: './name-manager.component.html',
  styleUrls: ['./name-manager.component.scss'],
  providers: [DatePipe]
})

export class NameManagerComponent implements OnInit {

  constructor(
    private _EquipmentService: EquipmentService,
    private datePipe: DatePipe) { this.userDetail = AccessUserInfo.getUserInfo(); }
  
  IPAddressFacilityDetail="";
  index:number=0;
  userDetail: UserDetail = null;
  public IsIpAddressEnabled: boolean = false;
  public IsNickNameEnabled: boolean = false;
  public isPaginatorVisible: boolean = false;
  public ErroDialog: boolean = false;

swVersions = {
  v1: 0,
  v2: 0,
  v3: 0
  }
   

  FaceilityMangerParams = {
    EquipmentIDList: "",
    facilityMasterIdList: "",
    manufacturerId: 0,
    modelId: 0,
    SerialNumber: "",
    UserName: null,
    SearchTerm: "Active",
    equipmentStatusId: null,
    MachineNickName: null,
    MachineIPAddress: null
  };
  NicknameParam: any = {
    "GETVALIDATEMACHINENICKNAME": {
      FacilityMasterID: 0,
      MachineNickName: "",
      EquipmentTypeId: 0,
      EquipmentSubTypeId: 0
    }
  }

  MachineIPAddressParam: any = {
    "VALIDATEMACHINEIPADDRESS": {
      facilitymasterid: 0,
      equipmenttypeid: "",
      equipmentsubtypeid: 0,
      machineipaddress: 0
    }
  }
  public ValidationData: any[] = [];
  FaceilityMangerData: EquipmentInfo[] = [];
  selectedEquipmentData: any;
  public userFacilities: SelectItem[];
  public selectedFacility: string;
  public IsVisible: boolean = false;
  public IsEditable: boolean = false;
  public IsViewMode: boolean = true;
  public displayHistoryPopUp: boolean = false;
  public equipmentId: number;
  public Datetime: Date;
  public ValidationMsg: any[];
  public Alertpopup: boolean = false;
  public Loding: boolean = false;
  GetEquipmentID = {
    EquipmentID: null
  };
  GetModelID = {
    ModelID: null
  };
  GetManfactureID = {
    manufacturerId: null
  }
  GETEQUIPMENTSTATUSID = {
    equipmentId: null,
  }
  UPDATEEQUIPMENTLOCATION = {
    equipmentId: null,
    facilityMasterId: null,
    equipmentStatusId: null,
    locationdescription: null,
    userid: null,
    dateModified: null
  }
  validateSerialPara = {
    ModelID: null,
    serial: null,
    strippedSerial: null
  }
  public ModelID: number;
  public ManfactureID: number;
  display: boolean = false;
  items: MenuItem[];
  FaceilityMangerColumns: any[];
  RepairResultColumns: any[];
  EuqipmentHistoryColumns: any[];
  SecheduleHistoryColumns: any[];
  RepairResultHistoryData: any[];
  EuqipmentHistory: any[];
  ScheduleHistory: any[];
  SelectedRowData: SelectedData;

  UpdateEquipmentData = {
    equipmentDescription: null,
    userid: null,
    equipmentId: null,
    MachineNickName: null,
    MachineIPAddress: null,
    ActuatorVersion: null,
    GeneralSoftwareVersion: null,
    FunctionalVersion: null
  };
  model: any[];
  manufacturarsList: SelectItem[];
  ModelList: SelectItem[];
  StatusList: SelectItem[];
  ModalityList: SelectItem[];
  ConditionList: SelectItem[];
  OriginList: SelectItem[];
  public EnableCustomSchedule: boolean = false;
  public srText: string = '';
  public custText: string = '';
  public errors: string = '';
  public ValidationMsgDailogbox: boolean = false;
  public equipStatusChanged: boolean = false;
  public StausDailogbox: boolean = false;
  ngOnInit() {
    this.userFacilities = [];
    this.Datetime = new Date()

    this.FaceilityMangerColumns = [{
      field: 'EquipmentTypeDescription',
      header: 'Equip. Type',
      display: 'table-cell'
    },
    {
      field: 'EquipmentSubTypeDescription',
      header: 'Sub-Type',
      display: 'table-cell'
    },
    {
      field: 'ManufacturerName',
      header: 'Manufacturer',
      display: 'table-cell'
    },
    {
      field: 'modelNumber',
      header: 'Model',
      display: 'table-cell'
    },
    {
      field: 'EquipmentSerialNumber',
      header: 'SN/IntID',
      display: 'table-cell'
    },
    {
      field: 'equipmentDescription',
      header: 'Equipment Description',
      display: 'table-cell',
    },
    {
      field: 'MachineNickName',
      header: 'NickName',
      display: 'table-cell'
    },
    {
      field: 'MachineIPAddress',
      header: 'IP Address',
      display: 'table-cell'
    },
    {
      field: 'GeneralSoftwareVersion',
      header: 'Software Version',
      display: 'table-cell'
    },
    {
      field: 'ActuatorVersion',
      header: 'Module 1',
      display: 'table-cell'
    },
    {
      field: 'FunctionalVersion',
      header: 'Module 2',
      display: 'table-cell'
    },

    {
      field: 'IsIpAddressEnabled',
      header: 'Is IpAddressEnabled',
      display: 'none'
    },
    {
      field: 'IsNickNameEnabled',
      header: 'Is NickNameEnabled',
      display: 'none'
    },
    {
      field: 'EquipmentTypeID',
      header: 'Equipment TypeID',
      display: 'none'
    },
    {
      field: 'EquipmentSubTypeID',
      header: 'Equipment Sub TypeID',
      display: 'none'
    },
    ];

    this.RepairResultColumns = [
      { field: 'TicketId', header: 'Ticket' },
      { field: 'WorkTypeDescription', header: 'Work Type' },
      { field: 'Sqadescription', header: 'SQA Code' },
      { field: 'DateServicePerformed', header: 'Repair Date' },
      { field: 'FullName', header: 'Repaired By' },
      { field: 'TicketStatusDescription', header: 'Ticket Status' },

    ];
    this.EuqipmentHistoryColumns = [


      { field: 'DateLocationChanged', header: 'Date' },
      { field: 'EquipmentStatusDescription', header: 'Status' },
      { field: 'FacilityName', header: 'Location' },
      { field: 'MachineIpaddress', header: 'IP Address', display: 'none' },
      { field: 'GeneralSoftwareVersion', header: 'Software Version', display: 'none' },
      { field: 'ActuatorVersion', header: 'Module 1', display: 'none' },
      { field: 'FunctionalVersion', header: 'Module 2', display: 'none' },
      { field: 'FullName', header: 'Modified By' },
    ]
    this.SecheduleHistoryColumns = [
      { field: 'DateModified', header: 'Date' },
      { field: 'IsActive', header: 'Active' },
      { field: 'OverrideReason', header: 'Override Reason' },
      { field: 'FullName', header: 'Modified By' },
    ];
  }
  public showDialog() {
    this.RepairResultHistoryData=[];
    this.EuqipmentHistory=[];
    this.ScheduleHistory=[];
    this.index=0;
    this.display = true;
    this.getRepairResults();
  }
  public clkModify() {
    this.IsEditable = true;
    this.IsViewMode = false;
  }

  public getUserLocationId(emittedLocationId: string) {
    this.IsVisible = false;
    this.FaceilityMangerParams.facilityMasterIdList = emittedLocationId;
    this.GetFaceilityManger();
  }

  public GetFaceilityManger() {
    this.FaceilityMangerData = [];
    this.Loding = true;
    this.FaceilityMangerParams.UserName = this.userDetail.userName;
    var GETFACILITYEQUIPMENTMANAGER = this.FaceilityMangerParams;
    this._EquipmentService.getFaceilityManger(JSON.stringify({
      GETFACILITYEQUIPMENTMANAGER
    }))
      .subscribe((Result: any) => {
        this.FaceilityMangerData = Result.facilityEquipment;
        this.FaceilityMangerData = this.FaceilityMangerData.sort((a, b) => a.modelNumber.toString() > b.modelNumber.toString() ? 1 : (a.modelNumber.toString() < b.modelNumber.toString() ? -1 : 0))
        this.Loding = false;
        this.isPaginatorVisible = true;
      },
        (respose: Response) => {
          this.Loding = false;
          // handle error here
        }
      );
  }


  public getRepairResults() {
    var request = {
      "GETREPAIRRESULTS": {
        "EquipmentID": this.GetEquipmentID.EquipmentID
      }
    }
    this._EquipmentService.getRepairResults(JSON.stringify(
      request
    ))
      .subscribe((Result: any) => {
        this.RepairResultHistoryData = Result.repairHistory;
        this.RepairResultHistoryData.forEach(item => item.DateServicePerformed = this.datePipe.transform(item.DateServicePerformed, "MM/dd/yyyy"));
      },
        (respose: Response) => {

          // handle error here
        }
      );
  }
  public getEquipmentHistoryResults() {
    var request = {
      "GETEQUIPMENTHISTORYRESULTS": {
        "EquipmentID": this.GetEquipmentID.EquipmentID
      }
    }

    this._EquipmentService.getEquipmentHistoryResults(JSON.stringify(
      request
    ))
      .subscribe((Result: any) => {
        this.EuqipmentHistory = Result.facilityEquipment;
        this.EuqipmentHistory.forEach(item => item.DateLocationChanged = this.datePipe.transform(item.DateLocationChanged, "MM/dd/yyyy"));
      },
        (respose: Response) => {

          // handle error here
        }
      );
  }

  public GetEquipmentScheduleHistory() {
    var request = {
      "GETEQUIPMENTSCHEDULEHISTORY": {
        "EquipmentID": this.GetEquipmentID.EquipmentID
      }
    }
    this._EquipmentService.getEquipmentScheduleHistory(JSON.stringify(
      request
    ))
      .subscribe((Result: any) => {
        this.ScheduleHistory = Result.equipmentSchedule;
      },
        (respose: Response) => {

          // handle error here
        }
      );
  }

  async UpdateEquipment() {

    this.Loding=true;
    this.ValidationData=[];
    this.errors = '';
    this.UpdateEquipmentData.equipmentDescription = this.SelectedRowData.equipmentdescription, //this.SelectedRowData["equipmentdescription"];
    this.UpdateEquipmentData.userid = this.userDetail.userId;
    this.UpdateEquipmentData.equipmentId = this.GetEquipmentID.EquipmentID;
    this.UpdateEquipmentData.MachineNickName = this.SelectedRowData.CurrentMachineNickName;
    this.UpdateEquipmentData.MachineIPAddress = this.SelectedRowData.CurrentMachineIPAddress;
    this.UpdateEquipmentData.ActuatorVersion = this.SelectedRowData.CurrentActuatorVersion;//this.SelectedRowData["ActuatorVersion"];
    this.UpdateEquipmentData.GeneralSoftwareVersion = this.SelectedRowData.CurrentGeneralSoftwareVersion;//this.SelectedRowData["GeneralSoftwareVersion"];
    this.UpdateEquipmentData.FunctionalVersion = this.SelectedRowData.CurrentFunctionalVersion;//this.SelectedRowData["FunctionalVersion"];

    let eqObjUpdateNickName = {
      "UPDATENICKNAME": {
        "equipmentDescription": this.UpdateEquipmentData.equipmentDescription,
        "userid": this.UpdateEquipmentData.userid,
        "equipmentId": this.UpdateEquipmentData.equipmentId,
        "MachineNickName": this.UpdateEquipmentData.MachineNickName,
        "MachineIPAddress": this.UpdateEquipmentData.MachineIPAddress,
        "ActuatorVersion": this.UpdateEquipmentData.ActuatorVersion,
        "GeneralSoftwareVersion": this.UpdateEquipmentData.GeneralSoftwareVersion,
        "FunctionalVersion": this.UpdateEquipmentData.FunctionalVersion
      }
    }
    var fieldsValid = await this.validateEquipmentFields(this.UpdateEquipmentData);
    if (fieldsValid) {
      this.Loding=false;
      this.ErroDialog = true;
    } else {

      this._EquipmentService.UpdateNickName(JSON.stringify(eqObjUpdateNickName))
        .subscribe((Result: any) => {

          this.model = Result;
          this.IsEditable = false;
          this.IsViewMode = true;
          this.IsVisible = false;
          this.GetFaceilityManger();
          this.Alertpopup = true;
          this.ErroDialog = false;
          this.Loding=false;
        },
          (respose: Response) => {

            // handle error here
            this.Loding=false;
          }
        );
      this.GetFaceilityManger();
    }
  }

  public OnRowClick(rowIndex) {
    //this.swVersions = null;
    if(this.selectedEquipmentData !=null)
    {
    this.IsNickNameEnabled = false;
    this.IsIpAddressEnabled = false;
    this.SelectedRowData == null;
    this.IsVisible = true;
    this.IsEditable = false;
    this.IsViewMode = true;
    let RowData: any = this.selectedEquipmentData;
    this.SelectedRowData = RowData;
    this.SelectedRowData["equipmentserialnumber"] = this.SelectedRowData["EquipmentSerialNumber"];
    this.SelectedRowData["equipmentdescription"] = this.SelectedRowData["equipmentDescription"];   
    this.SelectedRowData.CurrentMachineNickName = this.SelectedRowData["MachineNickName"];   
    this.SelectedRowData.CurrentMachineIPAddress = this.SelectedRowData["MachineIPAddress"];

    this.SelectedRowData.CurrentActuatorVersion = this.SelectedRowData["ActuatorVersion"];
    this.SelectedRowData.CurrentFunctionalVersion = this.SelectedRowData["FunctionalVersion"];
    this.SelectedRowData.CurrentGeneralSoftwareVersion = this.SelectedRowData["GeneralSoftwareVersion"];

    this.GetEquipmentID.EquipmentID = this.SelectedRowData["EquipmentID"];
    this.IsIpAddressEnabled = this.SelectedRowData["IsIpAddressEnabled"];
    this.IsNickNameEnabled = this.SelectedRowData["IsNickNameEnabled"];

    const commaSplitSWOptions = this.SelectedRowData['IsSoftwareEnabled'].split(',');
    // commaSplitSWOptions.forEach(x => { this.swVersions['v' + x.split('_')[0]] = x.split('_')[1]; });

    const arrayOptions = commaSplitSWOptions.map(function (i, d) { return i.split(',') });
    arrayOptions.forEach((x, y) => {
      if (x.toString().split('_')[0] !== '') {
        const swVer = 'v' + x.toString().split('_')[0];
        this.swVersions[swVer] = x.toString().split('_')[1];
      }
      else{
        this.swVersions['v1']=0
        this.swVersions['v2']=0
        this.swVersions['v3']=0
      }
    });
  }
  }
  public getKeyword(emittedKeyword: string) {
    this.IsVisible = false;
    this.FaceilityMangerParams.SearchTerm = emittedKeyword;
    this.GetFaceilityManger();
  }

  public TabChange(event: any) {
    this.index=event.index;
    if (event.index == 0) {
      this.getRepairResults();
    }
    if (event.index == 1) {
      this.getEquipmentHistoryResults();
    }
    if (event.index == 2) {
      this.GetEquipmentScheduleHistory();
    }
  }
  closeClick(eventId: string) {
    this.Alertpopup = false;
    this.ErroDialog = false;
  }
  StatusCommentPopup() {

  }
  async ValidateServiceNickName(GETVALIDATEMACHINENICKNAME) {    
    let result: boolean = false;
    await this._EquipmentService.validateMachineNickNameSync(JSON.stringify(GETVALIDATEMACHINENICKNAME))
      .then((ValidateResponse: any) => {
        if (ValidateResponse.machineNickName.length > 0) {
          result = true;
        } else {
          result = false;
        }
      });
    return result;
  }

  async ValidateServiceMachineIPAddress(VALIDATEMACHINEIPADDRESS) {
    var VALIDATEMACHINEIPADDRESSPARAM = {
      "VALIDATEMACHINEIPADDRESS": {
        "MachineIPAddress": VALIDATEMACHINEIPADDRESS

      }
    }
    let result: boolean = false;
    await this._EquipmentService.validateMachineIPAddressSync(JSON.stringify(VALIDATEMACHINEIPADDRESSPARAM))
      .then((ValidateResponse: any) => {
        if (ValidateResponse.length > 0) { 
              
          this.IPAddressFacilityDetail=ValidateResponse[0]["FacilityNumber"] + " - " + ValidateResponse[0]["FacilityName"] + " (" + ValidateResponse[0]["EquipmentSerialNumber"] + ")"
          result = true;
        } else {
          result = false;
        }
      });

    return result;

  }
  async ValidateMachineNickName() {
    let NickNamevalidate: boolean = false;
    this.NicknameParam.GETVALIDATEMACHINENICKNAME.FacilityMasterID = this.FaceilityMangerParams.facilityMasterIdList;
    this.NicknameParam.GETVALIDATEMACHINENICKNAME.EquipmentTypeId = this.SelectedRowData["EquipmentTypeID"];
    this.NicknameParam.GETVALIDATEMACHINENICKNAME.EquipmentSubTypeId = this.SelectedRowData["EquipmentSubTypeID"];
    this.NicknameParam.GETVALIDATEMACHINENICKNAME.MachineNickName = this.SelectedRowData.CurrentMachineNickName;
    NickNamevalidate = await this.ValidateServiceNickName(this.NicknameParam);   
    if (NickNamevalidate) {
      this.ValidationData.push("Nickname already exists; please verify and re-enter.  <br/>Existing Nickname: " + this.SelectedRowData.CurrentMachineNickName);
      NickNamevalidate = true;
    }
    return NickNamevalidate;
  }

  async validateEquipmentFields(equipData) {  
        
    this.ValidationData = [];
    let validateMesg: boolean = false;
    var oldIpAddress = this.SelectedRowData["MachineIPAddress"];
    var oldMachineNickName = this.SelectedRowData["MachineNickName"];
    {
      if (this.IsNickNameEnabled) {
        if (equipData.MachineNickName != undefined && equipData.MachineNickName != "") {
          if (!((equipData.MachineNickName >= 1 && (equipData.MachineNickName) <= 999))) {
            this.ValidationData.push("Equipment Nickname should be within the range of 1 - 999.");
            validateMesg = true;
          } else {
            
            if (equipData.MachineNickName != oldMachineNickName) {
              var val = await this.ValidateMachineNickName();
              if (val) {
                validateMesg = true;
              } else {
                validateMesg = false
              }
            }

          }
        }
      }

      if (equipData.equipmentDescription == "" || equipData.equipmentDescription == undefined || equipData.equipmentDescription == null) {        
        this.ValidationData.push("Equipment Description should not be blank.");
      }

      if (this.IsIpAddressEnabled) {
        var regExIPAddress = /^([0-9]{1,3})\.([0-9]{1,3})\.([0-9]{1,3})\.([0-9]{1,3})$/;
        if (equipData.MachineIPAddress != undefined && equipData.MachineIPAddress != "" && !regExIPAddress.test(equipData.MachineIPAddress)) {

          this.ValidationData.push("Equipment IP address is not valid.");
          validateMesg = true;
        } else {
          if (equipData.MachineIPAddress != oldIpAddress) {
            var val = await this.validateMachineIPAddress(equipData.MachineIPAddress);
            if (val) {
              validateMesg = true;
            } else {
              validateMesg = false
            }
          }
        }
      }      
      
      if (equipData.GeneralSoftwareVersion != undefined && equipData.GeneralSoftwareVersion != ""  && equipData.GeneralSoftwareVersion.length>10) {        
        this.ValidationData.push("Equipment Software Versions should be within 10 characters.");
      }      
      if (equipData.ActuatorVersion != undefined &&  equipData.ActuatorVersion != "" && equipData.ActuatorVersion.length>10) {        
        this.ValidationData.push("Equipment Module 1 should be within 10 characters.");
      }      
      if (equipData.FunctionalVersion != undefined &&  equipData.FunctionalVersion !="" && equipData.FunctionalVersion.length>10) {     
        this.ValidationData.push("Equipment Module 2 should be within 10 characters.");
      }
      //------------
    }
    if(this.ValidationData.length>0)
    {
      validateMesg=true;
    }
    return validateMesg
  }

  async validateMachineIPAddress(MachineIPAddress) {
    {      
      let IPAddressvalidate: boolean = false;
    
      IPAddressvalidate = await this.ValidateServiceMachineIPAddress(MachineIPAddress)

      if (IPAddressvalidate) {
        this.ValidationData.push("IP address already exists; please verify and re-enter. </br>Existing IP Address:" + MachineIPAddress + "<br/><br/>" + this.IPAddressFacilityDetail);
        IPAddressvalidate = true;
      }
      return IPAddressvalidate;
    }
  }
}

